import {base64DecodeUnicode} from "./utilities/base64";
import {initInputBody} from "./inputfile";
import {initInputMaskDate} from "./inputMaskDate";
import {initPhoneCountryFields} from "./phoneCountryField";
import {focusInputGroups} from "./checkInputGroups";

function loadRecaptchaHtml(formWrapper){
    formWrapper.innerHTML = base64DecodeUnicode(formWrapper.dataset.html);
    initInputMaskDate(formWrapper.querySelectorAll('input[type="date"],.js-inputMasketDate'));
    initInputBody(formWrapper.querySelectorAll('.fileBody'));
    initPhoneCountryFields(formWrapper.querySelectorAll("input[type=tel]"));
    focusInputGroups(formWrapper.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));
    if(formWrapper.querySelector(".contactform")){
        formWrapper.querySelector(".contactform").style.opacity = 1;
    }
    formWrapper.querySelector("form").addEventListener("submit", function (e) {
        e.preventDefault();
        grecaptcha.execute();
    });
}

export function initRecaptchaForms(wrapper = document){
    const observer = new MutationObserver(function (mutationList,observer){
        for(let mutation of mutationList){
            let target = mutation.target;
            if(target){
                loadRecaptchaHtml(target);
            }
        }
    });

    for(let form of wrapper.querySelectorAll('.js-RecaptchaForm')){
        if(form.dataset.html){
            // Cookie consent (DCCookie) may already have set data-html before this observer
            // attaches (e.g. returning visitors with stored consent, fast Edge reloads).
            // A MutationObserver only catches mutations after observe() runs, so decode now.
            loadRecaptchaHtml(form);
            continue;
        }
        observer.observe(form, {
            attributes: true,
            childList: false,
            subtree: false
        });
    }
}